import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

// ─── AeroMax CRM (EnergySuite) ───────────────────────────────────────────
const CRM_BASE_URL = "https://api-aeromax.energysuite.com.au";

// Shared CRM POST — never throws; returns the parsed JSON envelope or null.
async function crmPost(path, body) {
  try {
    const res = await fetch(`${CRM_BASE_URL}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {}),
    });
    if (!res.ok) return null;
    return await res.json().catch(() => null);
  } catch {
    return null;
  }
}

// Create a prospect; returns the new id or null.
export async function submitProspectCRM(payload) {
  const json = await crmPost("/member/web/prospect/create", payload);
  return json?.data?.id || null;
}

// Fetch a prospect by id; returns its data or null.
export async function getProspectDetails(id) {
  if (!id) return null;
  const json = await crmPost("/member/web/prospect/details", { id });
  return json?.data || null;
}

// Fetch members of a CRM department; returns an array.
export async function getMembers(department) {
  const json = await crmPost("/member/web/members/get", { department });
  return Array.isArray(json?.data) ? json.data : [];
}

// Assessors (ASSESSMENTS dept) and energy-saving specialists / agents (AGENT dept).
export const getAssessmentMembers = () => getMembers("ASSESSMENTS");
export const getAgents = () => getMembers("AGENT");

// Fetch an assessor's free slots for a date (YYYY-MM-DD); returns an array.
export async function getAssessorSlots(memberId, scheduleDate) {
  if (!memberId || !scheduleDate) return [];
  const json = await crmPost("/member/web/assessor/slots/get", { memberId, scheduleDate });
  return Array.isArray(json?.data) ? json.data : [];
}

// Convert a prospect to a booked assessment (multipart; `attachments` = File or
// File[], each sent as "attachment"). Returns true on 2xx, false otherwise.
export async function convertProspect(fields, attachments) {
  try {
    const fd = new FormData();
    Object.entries(fields || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") fd.append(k, v);
    });
    const files = Array.isArray(attachments)
      ? attachments
      : attachments
      ? [attachments]
      : [];
    files.forEach((file) => file && fd.append("attachment", file));
    const res = await fetch(`${CRM_BASE_URL}/member/web/prospect/convert`, {
      method: "POST",
      body: fd, // let the browser set the multipart boundary
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function calcEstimate(payload) {
  const { data } = await api.post("/calculator/estimate", payload);
  return data;
}

export async function adminLogin(username, password) {
  const { data } = await api.post("/admin/login", { username, password });
  return data;
}

export async function adminLogout(token) {
  const { data } = await api.post("/admin/logout", {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchAdminLeads(token) {
  const { data } = await api.get("/admin/leads", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchAdminStats(token) {
  const { data } = await api.get("/admin/stats", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
